import { useConsultation } from '@entities/consultations';
import differenceInMinutes from 'date-fns/differenceInMinutes';
import parseISO from 'date-fns/parseISO';
import type React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { CoachModalCard } from '@widgets/coaches';
import { Calendar, Description, Diploma, ScheduleButton } from '@features/coaches';
import { useConsultationLoader } from '@features/consultations';
import { LargeHeader } from '@shared/ui';
import { useCoachQuery } from '@src/api/api-hooks/coaches/useCoachQuery.ts';
import { ModalLarge } from '@src/library/components/common';
import * as st from './styles.module.scss';

const fields: {
  [x: string]: string;
} = {
  ON: 'consultation_duration',
  OF: 'consultation_offline_duration',
};

export const ChoosePeriod: React.FC = () => {
  const { code, moveParams = '' } = useParams<{ [x: string]: string }>();
  const navigate = useNavigate();
  const {
    consultationId,
    coachId,
    mode,
  }: { consultationId: number; coachId: number; mode: string } = JSON.parse(moveParams);

  useConsultationLoader(consultationId);

  const onClose = () => navigate(`/consultations/${code}/consultation/${consultationId}`);

  const { data: coach } = useCoachQuery({ id: String(coachId) });
  const { consultation } = useConsultation(consultationId);

  const onScheduleClick = (id: number) => {
    if (!coach || !consultation) return;
    const coachDuration = parseFloat(coach[fields[mode]] as string) * 30;
    const consultationDuration = differenceInMinutes(
      parseISO(consultation.end_time),
      parseISO(consultation.start_time)
    );

    const isDurationEquel = coachDuration === consultationDuration;

    if (!isDurationEquel) return console.log('Невозможно перенести консультацию');

    return navigate(
      `/consultations/${code}/consultation-move/${JSON.stringify({
        consultationId: consultationId,
        coachId: coachId,
        mode: mode,
        availablePeriodId: id,
      })}`
    );
  };

  return (
    <ModalLarge isOpen disableHeader onRequestClose={onClose}>
      <LargeHeader title="Выбрать график" onClose={onClose} />
      <div className={st.coach}>
        <CoachModalCard
          id={coachId}
          ModeSwitch={<ScheduleButton mode={mode} coachId={coachId} isActive />}
          Calendar={<Calendar mode={mode} coachId={coachId} onClick={onScheduleClick} />}
        />
        <Description id={coachId} />
        <Diploma id={coachId} />
      </div>
    </ModalLarge>
  );
};
